module.exports = __webpack_public_path__ + "23_cikm_4.jpg?d6ed0df5939f352d40ff1f9f3f1904b3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/23_cikm_4.jpg
// module id = 199
// module chunks = 0